export const createSample = (sample) => {
    console.log("action dispatch");
    return (dispatch, getState)=>{
        dispatch({type: "ADD_SAMPLE",
        sample: sample});
    };
}